import React, { useEffect, useState } from "react";
import '../../../App.css';
import ApiHandler from "../../../ApiHandler";
import GlobalVariable from "../../../GlobalVariable";
import { midContentHeight } from "../Home";
// import BearVerticalMarquee from 'bear-react-vertical-marquee';
// import 'bear-react-vertical-marquee/dist/index.css';

function MarqueeLComList() {

    const [companyList, setCompanyList] = useState([]);

    useEffect(() => {
        ApiHandler.get({

            //url: localUrl + "api/OwnApp/GetComOrderList",
            url: "/api/POPSReports/AllCompanies/" + GlobalVariable.wcClient,

        })
            .then(((result) => {

                console.log(result);
                setCompanyList(result)
            }))
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }

            })
    }, [])

    return (
        <>
            <div className="overflow pl-lg-3"
                style={{
                    // height: window.innerHeight / 1.5,
                    height: midContentHeight,
                    border: "none"
                }}
            >

                {companyList && companyList.length > 0 && <div className="scroll-container">
                    <div className="scroll-content">
                        {companyList.map((item, index) => (
                            <div key={item.compCode} className="name-item">{item.name}</div>
                        ))}
                    </div>
                </div>}


                {/*  eslint-disable-next-line jsx-a11y/no-distracting-elements */}
                {/* {companyList && companyList.length > 0 && <marquee
                    direction='up'
                    scrollamount="2"
                    style={{ height: "100%" }} >
                    {
                        companyList.map((item) => <li key={item.compCode}  >{item.name}</li>)
                    }
                </marquee>
                } */}
            </div>

        </>)
}
export default MarqueeLComList;


